import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Breadcrumb = ({ title }) => {

  const {t} = useTranslation()

  return (
    <div className='mb-0 breadcrumb py-26 bg-main-two-50'>
      <div className='container container-lg'>
        <div className='flex-wrap gap-16 breadcrumb-wrapper flex-between'>
          <h6 className='mb-0'>{title}</h6>
          <ul className='flex-wrap gap-8 flex-align'>
            <li className='text-sm'>
              <Link
                to='/'
                className='gap-8 text-gray-900 flex-align hover-text-main-600'
              >
                <i className='ph ph-house' />
                {t('common.home')}
              </Link>
            </li>
            <li className='flex-align'>
              <i className='ph ph-caret-right' />
            </li>
            <li className='text-sm text-main-600'> {title} </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;
